export class EmployeeAttribute {
    attrNo: number;
    attrHeader: string;
    attrName: string;
    empresaId: number;
}